import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { logAnalyticsEvent } from './analytics';

export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    logAnalyticsEvent('page_view', { page_path: location.pathname });
  }, [location.pathname]);
}
